import { CanvasFolderDialog } from "@/action-dialog/dialogs/CanvasFolderDialog";
import type { Folder, FolderResourceType } from "@cohesive/api-client";
import { useRef } from "react";
import { createCallable } from "react-call";

const UNMOUNTING_DELAY_MS = 200;

export type CanvasFolderCallableProps = {
  workspaceId: string;
  /** Parent for a newly created folder (null = workspace root). Ignored in rename. */
  parentFolderId?: string | null;
  /** When set, the dialog renames this folder instead of creating one. */
  folder?: Folder;
  /** The kind of resource the folder organizes. Defaults to canvas. */
  resourceType?: FolderResourceType;
};

export const CanvasFolderCallable = createCallable<
  CanvasFolderCallableProps,
  boolean
>(({ call, workspaceId, parentFolderId, folder, resourceType }) => {
  const succeededRef = useRef(false);

  return (
    <CanvasFolderDialog
      workspaceId={workspaceId}
      parentFolderId={parentFolderId}
      folder={folder}
      resourceType={resourceType}
      onClose={() => {
        call.end(succeededRef.current);
        succeededRef.current = false;
      }}
      onSuccess={() => {
        succeededRef.current = true;
      }}
    />
  );
}, UNMOUNTING_DELAY_MS);

CanvasFolderCallable.displayName = "CanvasFolderCallable";
